export const iconFontAwesomeCommunicationAddressCard = (
	<i className="fa-solid fa-address-card"></i>
);
